module.exports = __webpack_public_path__ + "assets/ic-coinmarketcap.6d46b063.svg";